/* eslint-disable */
import Chatbot                  from 'app/common/chatbot'
import AuthorizationContext     from 'auth/keycloak-instance';
import useTranslate             from 'app/common/hooks/translate';

const ApplicationFooter = props => {
    const t                 = useTranslate();

    return (
        <div className="application-wrapper-footer">
            <div className="application-wrapper-footer-left">
                <div className="company-info-container">
                    <div className="copyright">© { new Date().getFullYear() } Simpra</div>
                    <div className="web-url"><a href="https://simprasuite.com/" rel="noreferrer noopener" target="_blank">simprasuite.com.tr</a></div>
                </div>  
                <div className="social-media-container">
                    <a href="https://x.com/simpra_tr/" rel="noreferrer noopener" onClick={ () => console.log('eben') } target="_blank" className="twitter">&nbsp;</a>
                    <a href="https://www.youtube.com/@simpra_tr" rel="noreferrer noopener" target="_blank" className="youtube">&nbsp;</a>
                    <a href="https://www.instagram.com/simpra_tr/" rel="noreferrer noopener" target="_blank" className="instagram">&nbsp;</a>
                    <a href="https://www.linkedin.com/company/simpra-tr/posts/?feedView=all" rel="noreferrer noopener" target="_blank" className="linkedin">&nbsp;</a>
                    <a href="https://blog.simprasuite.com/" rel="noreferrer noopener" target="_blank" className="medium">&nbsp;</a>
                </div> 
            </div>
            {/* <Chatbot userData={ AuthorizationContext.user } t={ t } /> */}
        </div>
    )
}

export default ApplicationFooter
/* eslint-enable */